module.exports = __webpack_public_path__ + "static/media/gestioneRichiesteServizi.dd9fec93.png";